import { ActionKeys } from './constants';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function sendTrackEvent(name: string, properties?: { [key: string]: any }) {
  return <const>{
    name,
    properties,
    type: ActionKeys.PROD_ANALYTICS_TRACK,
  };
}

export function addEventProperties(properties: { [key: string]: string | number | boolean }) {
  return <const>{
    properties,
    type: ActionKeys.PROD_ANALYTICS_ADD_EVENT_PROPERTIES,
  };
}

export type ProductAnalyticsActions =
  | ReturnType<typeof sendTrackEvent>
  | ReturnType<typeof addEventProperties>;
